// extracted by mini-css-extract-plugin
module.exports = {"root":"ReportModalFilter_root__3YKMz","footer":"ReportModalFilter_footer__13g15"};